import { sharedInitialValues } from '../shared/sharedInitialValues';

export const initialValues = (values = {}, noProduct = false) => ({
    registerEmail: '',
    password: '',
    confirmPassword: '',
    acceptRegistrationTerms: false,
    ...sharedInitialValues(values, noProduct),
});
